<template>
	<el-card v-show="article.length > 0">
		<div slot="header" class="article header">
			<img src="../image/article_new.png" class="header-icon">
			<span class="header-title">Learn</span>
		</div>
		<ArticleTable
			:patient="patient"
			v-bind:article="article">
		</ArticleTable>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import ArticleTable from './Table'

export default {
	name: 'patient-article-card',
	extends: OverviewCard,

	computed: {
		article() {
			return this.patientEventType('article')
		}
	},

	components: {
		ArticleTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
@import "./style.scss";
</style>
